// src/services/personService.js
import { authFetch } from '../utils/api';

const handleResponse = async (response) => {
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const error = new Error(data.error || data.message || `Erreur ${response.status}`);
        error.response = { status: response.status, data };
        throw error;
    }
    return response.json();
};

const personService = {
    getAllPersons: async (userId) => {
        try {
            // ⭐ On appelle authFetch.get
            const response = await authFetch.get(`/persons/${userId}`);
            return await handleResponse(response);
        } catch (error) {
            console.error("Erreur dans personService:", error.message);
            throw error;
        }
    }
};

export default personService;